import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-genesis-with-text.svg'
import _imports_1 from '@/app/ui/assets/svg/login-approval/login-rejected.png'


const _hoisted_1 = { class: "bg-gray-lp-100 w-screen h-screen" }
const _hoisted_2 = {
  id: "login-approval",
  class: "mx-auto flex flex-col items-center justify-center gap-6",
  style: {"max-width":"600px","padding-top":"17.5vh"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"width":"184.5px"},
  alt: "logo genesis"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"124px"},
  alt: "illustration login rejected"
}, null, -1)
const _hoisted_5 = { class: "flex flex-col justify-center items-center gap-8" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "font-semibold text-2xl text-black-lp-100 text-center",
  "data-testid": "auth-inactive-account-title"
}, "Your Account Has Been Deactivated", -1)
const _hoisted_7 = {
  style: {"margin-top":"50px"},
  class: "text-sm text-black-lp-300 text-center"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" eed help? Contact via:")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { "data-testid": "auth-inactive-account-link-whatsapp" }, "WhatsApp ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { "data-testid": "auth-inactive-account-link-email" }, "Email ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  href: "mailto:system@thelionparcel.com",
  class: "text-red-lp-100 underline"
}, " system@thelionparcel.com", -1)
const _hoisted_14 = {
  class: "relative w-full",
  style: {"margin-top":"90px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("span", {
          class: "text-xl text-black-lp-300 text-center",
          "data-testid": "auth-inactive-account-body",
          innerHTML: `For security, accounts with no activity for 30 days are temporarily deactivated. Please contact our Helpdesk to reactivate your account.`
        }, null, 8, ["innerHTML"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createVNode("a", {
          href: `https://wa.me/${_ctx.cleanPhoneNumber(_ctx.phoneNumberHD)}`,
          class: "text-red-lp-100 underline",
          target: "_blank",
          rel: "noopener noreferrer"
        }, _toDisplayString(_ctx.phoneNumberHD), 9, ["href"]),
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}